import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import SshSecurityInformationList from './containers/SshSecurityInformationList';
import SshSecurityInformationCreate from './containers/SshSecurityInformationCreate';
import SshSecurityInformationEdit from './containers/SshSecurityInformationEdit';
import SshSecurityInformationView from './containers/SshSecurityInformationView';
import { SYSTEM_CONFIGURATION_ROUTE, SSH_SECURITY_INFORMATION, SECURITY } from '../../constants';

interface Props {
}

const SshSecurityInformation: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${SSH_SECURITY_INFORMATION}`}>
        <SshSecurityInformationList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${SSH_SECURITY_INFORMATION}/create`}>
        <SshSecurityInformationCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${SSH_SECURITY_INFORMATION}/edit`}>
        <SshSecurityInformationEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${SSH_SECURITY_INFORMATION}/view`}>
        <SshSecurityInformationView />
      </Route>
    </Fragment>
  );
};

export default SshSecurityInformation;
